import script from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomModal.vue?vue&type=style&index=0&id=051b58f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051b58f5"]])

export default __exports__